import { createFileRoute } from "@tanstack/react-router";
import OrderHistoryScreen from "../Screens/OrderHistory";

export const Route = createFileRoute("/order-history")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrderHistoryScreen />;
}
